export default {
      id: "handwriting-arrow-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#handwriting-arrow",
      toString: function () {
        return this.url;
      }
    }